import React from 'react'
import {
    FormControl,
    FormLabel,
    Radio,
    RadioGroup,
    Grid,
    useMediaQuery,
    Text,
} from "@chakra-ui/react";

export const FormRadio = ({ id, name, radioGroupName, value, onChange, array, isObject, padding, isRequired, disabled, noOfItem=null }) => {

    const [largeScreen] = useMediaQuery("(max-width: 1100px)");
    const [smallScreen] = useMediaQuery("(max-width: 850px)");

    return (
        <FormControl id={id} padding={padding} isRequired={isRequired}>
            <FormLabel 
                fontSize="15px"
                textTransform="capitalize"
                fontWeight={600}
            >
                {name}
            </FormLabel>
            <RadioGroup
                onChange={onChange}
                value={value}
                name={radioGroupName}
                isDisabled={disabled}
            >
                <Grid templateColumns={`${smallScreen ? "repeat(3, 1fr)" : largeScreen ? "repeat(4, 1fr)" : noOfItem ? `repeat(${noOfItem}, 1fr)` : "repeat(5, 1fr)"}`} gap={3}>
                    {array.map((item) => (
                        isObject ?
                            <Radio key={item.id} value={item.id}>
                                <Text as="span">{item.name}</Text>
                            </Radio> :
                            <Radio key={item} value={item === "Yes" ? true : item === "No" ? false : item}>
                                {item}
                            </Radio>
                    ))}
                </Grid>
            </RadioGroup>
        </FormControl>
    )
}